import { createFileRoute, redirect } from '@tanstack/react-router'

// Legacy route: breach/broker monitoring consolidated onto /footprint
// (the "Breach Monitor") in the 2026-06 IA consolidation (TD-016).
export const Route = createFileRoute('/_auth/data-brokers')({
  beforeLoad: () => {
    throw redirect({ to: '/footprint', replace: true })
  },
})
